import React, { Component } from "react";
import { connect } from "react-redux";

import LoadingPage from "../../../components/LoadingPage";

import SidebarItems from "../Sidebar/SidebarItems";
import PrivateSwitch from "../PrivateSwitch";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";

class PageLayout extends Component {
  state = {
    collapsed: false,
    isAdmin: this.props.api.permission.sm_solution_access,
    smReportDelete: this.props.api.permission.sm_report_delete,
    permission: this.props.api.permission,
  };
  componentDidMount() {
    const { user, api: { smData: { data: { _id, email, name, user_name, role_name } = {} } = {} } = {} } = this.props;
    this.initPendo(
      {
        userId: _id,
        userEmail: email,
        userName: user_name,
        name: name,
        role: role_name,
      }
    );
  }
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };
  handleLogout = (e) => {
    e.preventDefault();
    this.props.logout();
  };

  initPendo(pendoObj) {
    (function (apiKey) {
      (function (p, e, n, d, o) {
        var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = [];
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) {
          o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
        })(v[w]);
        y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
      })(window, document, 'script', 'pendo');

      // Call this whenever information about your visitors becomes available
      // Please use Strings, Numbers, or Bools for value types.
      let visitorObject = {
        id: pendoObj.userId,  // Required if user is logged in
        email: pendoObj.userEmail,     // Recommended if using Pendo Feedback, or NPS Email
        full_name: pendoObj.name,
        role: pendoObj.role,
        environment: "myAdmin - " + process.env["REACT_APP_PLATFORM_TYPE"].toLowerCase() + "-" + process.env["REACT_APP_ENVIRONMENT"],


        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
      };

      let accountObject = (pendoObj.entityId == null || pendoObj.hmg == null) ? ({
        id: "",    // Highly recommended
        // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
      }) : ({
        id: pendoObj.entityId,    // Highly recommended
        name: pendoObj.hmg,
        type: "HMG"         // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
      });

      window.pendo.initialize({
        visitor: visitorObject,
        account: accountObject
      });
    })('2fac6f5d-004e-43e7-67d1-dd1de411e110');
  }



  render() {
    return (
      <div className={`dashboard_a ${this.state.collapsed ? " is_open" : ""}`}>
        <Header
          nickName={this.props.user.nickname}
          handleLogout={this.handleLogout}
          permission={this.state.permission}
        />
        <div className="wrapper_page">
          <Sidebar collapsed={this.state.collapsed} toggle={this.toggle}>
            <SidebarItems
              isSmReportDelete={this.state.smReportDelete}
              permission={this.state.permission}
              collapsed={this.state.collapsed}
            />
          </Sidebar>
          <div className="wrapper_a">
            <div className="container_a">
              {this.props.api.loading ? <LoadingPage /> : null}

              <PrivateSwitch permission={this.props.api.permission} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    count: state.counter,
    api: state.api,
    qcApi: state.qcApi,
  };
};

export default connect(mapStateToProps, null)(PageLayout);
